module.exports = __webpack_public_path__ + "static/ceo-tim-gerend.ca5b5c6f.webp";